import { injectable } from "inversify";

export interface IframeNotifier {
  notify(payload?: any): void;
}

@injectable()
export class IframeNotifierImpl implements IframeNotifier {
  notify(payload?: any): void {
    const insideIframe = window.self !== window.parent;
    if (insideIframe) {
      window.parent.postMessage(payload, "*");
    }
  }
}
